import { View } from './view'

export const BlocksWithIcons = View
